var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62CD4D"
    },
    d: "M403.951,400.989c53.019,0,96-42.981,96-96c0-28.026-12.013-53.245-31.167-70.795 c-0.901-35.045-29.572-63.182-64.833-63.182V400.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAEA83"
    },
    d: "M176.895,433.284c0-34.023-27.581-61.604-61.604-61.604s-61.604,27.581-61.604,61.604 c0,8.288,1.647,16.188,4.615,23.406c-0.966-0.062-1.938-0.104-2.92-0.104c-25.037,0-45.333,20.296-45.333,45.333h166.846 C176.895,498.84,176.895,467.307,176.895,433.284z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.19,
    y: 126,
    style: {
      fill: "#C9F3FF"
    },
    width: 295.76,
    height: 376
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 216.61,
    y: 392,
    style: {
      fill: "#72D8FF"
    },
    width: 80,
    height: 110
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.61,
    y: 180,
    style: {
      fill: "#72D8FF"
    },
    width: 48,
    height: 56
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 232.61,
    y: 180,
    style: {
      fill: "#FFFFFF"
    },
    width: 48,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.6,
    y: 180,
    style: {
      fill: "#FFFFFF"
    },
    width: 48,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.61,
    y: 286,
    style: {
      fill: "#FFFFFF"
    },
    width: 48,
    height: 56
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 232.61,
    y: 286,
    style: {
      fill: "#72D8FF"
    },
    width: 48,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.6,
    y: 286,
    style: {
      fill: "#72D8FF"
    },
    width: 48,
    height: 56
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC66C"
    },
    d: "M325.577,485.159h114.936h32.118l29.321,0.05v-32.742c0-15.862-12.859-28.721-28.721-28.721h-90.185 h-0.008H284.8c-15.862,0-28.721,12.859-28.721,28.721v32.742l34.104-0.05H325.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9F3FF"
    },
    d: "M412.068,362.857h-74.705c-9.22,0-17.547,5.511-21.15,13.998l-19.907,46.891h156.819l-19.907-46.891 C429.615,368.368,421.288,362.857,412.068,362.857z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#898998"
    },
    cx: 309.52,
    cy: 482,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#898998"
    },
    cx: 456.57,
    cy: 482,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.541,411.76c1.86,1.86,4.439,2.93,7.07,2.93c2.63,0,5.21-1.069,7.069-2.93c1.86-1.86,2.931-4.44,2.931-7.07 c0-2.64-1.07-5.21-2.931-7.069c-1.859-1.86-4.43-2.931-7.069-2.931c-2.631,0-5.21,1.07-7.07,2.931 c-1.86,1.859-2.93,4.439-2.93,7.069S136.681,409.899,138.541,411.76z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.191,226.5c2.64,0,5.21-1.07,7.069-2.931c1.86-1.859,2.931-4.439,2.931-7.069s-1.07-5.21-2.931-7.07 c-1.859-1.86-4.43-2.93-7.069-2.93c-2.631,0-5.211,1.069-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07s1.069,5.21,2.93,7.069 C102.98,225.43,105.561,226.5,108.191,226.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.613,246h48c5.522,0,10-4.478,10-10v-56c0-5.522-4.478-10-10-10h-48c-5.522,0-10,4.478-10,10v56 C135.613,241.522,140.091,246,145.613,246z M155.613,190h28v36h-28V190z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M232.606,246h48c5.522,0,10-4.478,10-10v-56c0-5.522-4.478-10-10-10h-48c-5.522,0-10,4.478-10,10v56 C222.606,241.522,227.084,246,232.606,246z M242.606,190h28v36h-28L242.606,190L242.606,190z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M319.6,246h48c5.522,0,10-4.478,10-10v-56c0-5.522-4.478-10-10-10h-48c-5.522,0-10,4.478-10,10v56 C309.6,241.522,314.077,246,319.6,246z M329.6,190h28v36h-28V190z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.613,342c0,5.522,4.478,10,10,10h48c5.522,0,10-4.478,10-10v-56c0-5.522-4.478-10-10-10h-48c-5.522,0-10,4.478-10,10 V342z M155.613,296h28v36h-28V296z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M222.606,342c0,5.522,4.478,10,10,10h48c5.522,0,10-4.478,10-10v-56c0-5.522-4.478-10-10-10h-48c-5.522,0-10,4.478-10,10 L222.606,342L222.606,342z M242.606,296h28v36h-28L242.606,296L242.606,296z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M309.6,333c0,5.522,4.478,10,10,10s10-4.478,10-10v-37h28v37c0,5.522,4.478,10,10,10s10-4.478,10-10v-47 c0-5.522-4.478-10-10-10h-48c-5.522,0-10,4.478-10,10V333z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.118,106V10c0-5.522-4.478-10-10-10s-10,4.478-10,10v38h-36V10c0-5.522-4.478-10-10-10s-10,4.478-10,10v96 c0,5.522,4.478,10,10,10s10-4.478,10-10V68h36v38c0,5.522,4.478,10,10,10S122.118,111.522,122.118,106z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M283.784,106V20h18c5.522,0,10-4.478,10-10s-4.478-10-10-10h-56c-5.522,0-10,4.478-10,10s4.478,10,10,10h18v86 c0,5.522,4.478,10,10,10S283.784,111.522,283.784,106z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M225.451,78V38c0-20.953-17.047-38-38-38s-38,17.047-38,38v40c0,20.953,17.047,38,38,38S225.451,98.953,225.451,78z  M205.451,78c0,9.925-8.075,18-18,18s-18-8.075-18-18V38c0-9.925,8.075-18,18-18s18,8.075,18,18V78z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M473.229,413.746h-13.486l-6.085-14.334c34.316-17.567,57.859-53.297,57.859-94.423c0-28.249-11.394-55.456-31.396-75.295 c-1.471-17.983-9.301-34.677-22.314-47.387c-12.03-11.75-27.366-18.964-43.855-20.808V136h22.959c5.522,0,10-4.478,10-10 s-4.478-10-10-10h18.874c5.522,0,10-4.478,10-10s-4.478-10-10-10h-32.333V10c0-5.522-4.478-10-10-10s-10,4.478-10,10v96 c0,5.522,4.478,10,10,10h-9.5h-28.833c5.522,0,10-4.478,10-10s-4.478-10-10-10h-32.334V68h32.334c5.522,0,10-4.478,10-10 s-4.478-10-10-10h-32.334V20h32.334c5.522,0,10-4.478,10-10s-4.478-10-10-10h-42.334c-5.522,0-10,4.478-10,10v96 c0,5.522,4.478,10,10,10h-59h-86.333h-75.333h-3.925H74.992c-5.522,0-10,4.478-10,10s4.478,10,10,10h23.201v45.938 c0,5.522,4.478,10,10,10s10-4.478,10-10V136h275.758v216.856h-56.589c-13.259,0-25.174,7.886-30.354,20.09L303.164,382h-86.558 c-5.522,0-10,4.478-10,10v100h-28.502c-0.397-0.048-0.799-0.08-1.209-0.08h-21.282v-54.735c0-5.522-4.478-10-10-10s-10,4.478-10,10 v54.735h-17.42V253c0-5.522-4.478-10-10-10s-10,4.478-10,10v110.745c-14.381,3.533-27.422,11.502-37.183,22.838 c-11.171,12.975-17.323,29.56-17.323,46.7c0,4.828,0.477,9.592,1.424,14.259C19.49,452.37,0.049,474.917,0.049,501.92 c0,5.522,4.478,10,10,10L255.951,512c5.522,0,10-4.478,10-10c0-2.63-1.023-5.016-2.684-6.801l19.302-0.031 c4.886,9.958,15.128,16.832,26.948,16.832c11.824,0,22.068-6.878,26.953-16.841h93.148c4.884,9.963,15.129,16.841,26.953,16.841 c11.804,0,22.033-6.854,26.927-16.79h18.453c5.522,0,10-4.478,10-10v-32.742C511.951,431.116,494.581,413.746,473.229,413.746z  M438.016,413.746h-53.3v-40.89h27.353c5.218,0,9.905,3.104,11.944,7.906L438.016,413.746z M460.354,234.45 c0.07,2.714,1.24,5.282,3.241,7.116c17.745,16.26,27.922,39.376,27.922,63.422c0,32.867-18.54,61.474-45.704,75.945l-3.391-7.986 c-4.934-11.623-15.979-19.313-28.472-20.021v-171.28C439.895,185.571,459.658,207.354,460.354,234.45z M337.362,372.856h27.354 v40.89h-53.301l14.003-32.984C327.456,375.96,332.146,372.856,337.362,372.856z M226.606,402h68.067l-4.987,11.746H284.8 c-21.352,0-38.722,17.37-38.722,38.722v32.742c0,2.525,0.964,4.945,2.674,6.79h-22.146L226.606,402L226.606,402z M55.383,466.586 c0.665,0,1.392,0.026,2.285,0.083c3.447,0.229,6.752-1.351,8.761-4.152c2.01-2.802,2.434-6.441,1.123-9.63 c-2.564-6.235-3.864-12.831-3.864-19.604c0-22.397,14.063-41.641,34.506-48.725V491.92H21.489 C25.813,477.29,39.371,466.586,55.383,466.586z M266.078,452.468c0-10.323,8.398-18.722,18.722-18.722h11.506h68.41v41.413h-25.995 C335.617,461.904,323.706,452,309.518,452c-14.192,0-26.106,9.91-29.207,23.172l-14.233,0.023V452.468z M309.518,492 c-5.514,0-10-4.486-10-10s4.486-10,10-10s10,4.486,10,10S315.031,492,309.518,492z M456.571,492c-5.514,0-10-4.486-10-10 s4.486-10,10-10s10,4.486,10,10S462.085,492,456.571,492z M491.951,475.21h-6.165C482.7,461.929,470.777,452,456.571,452 c-14.188,0-26.099,9.904-29.204,23.159h-42.652v-41.413h88.514c10.323,0,18.722,8.398,18.722,18.722V475.21z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M349.437,461.293c5.522,0,10-4.478,10-10v-0.075c0-5.522-4.478-9.963-10-9.963s-10,4.516-10,10.038 S343.914,461.293,349.437,461.293z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/Hotel.855e889f565ffd1d471575caf4a76ce8.svg";
export { ForwardRef as ReactComponent };